import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export default function useAuthorizedDomainForm({ domainInfo }) {
  return useForm({
    defaultValues: {
      ...defaultValues,
      ...domainInfo,
      credentials: null,
    },
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });
}

const defaultValues = {
  name: '',
  esp: 'Gmail accounts',
  credentials: null,
  isActive: false,
  credentialsUpdated: false,
};

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .label('Domain Name'),
  esp: yup
    .string()
    .required()
    .label('ESP'),
  credentials: yup
    .mixed()
    .test('fileRequired', 'File is required', value => {
      return value instanceof File;
    })
    .label('Credentials'),
  isActive: yup
    .boolean()
    .required()
    .label('Is Active'),
  credentialsUpdated: yup
    .boolean()
    .required()
    .label('Credentials Updated'),
});

export const commonProps = ({ fieldState, field }) => {
  return {
    error: !!fieldState.error,
    value: field.value,
    helperTxt: fieldState.error?.message,
    onBlur: field.onBlur,
    onChange: field.onChange,
    name: field.name,
    id: `gsuite-${field.name}`,
  };
};
